import '../common/common';

import $ from 'jquery';
import { getModelInfo, populateBrands, populateModel } from '../lib/modelLookup';

declare global {
  interface Window {
    plausible: (event: string, options?: { [key: string]: any }) => void;
  }
}

$(() => {
  const brandSelector = $("#radioBrandSelector");
  const modelSelector = $("#radioModelSelector");

  modelSelector.trigger("reset");

  brandSelector.on("change", function () {
    if (brandSelector.children(":selected").val()) {
      brandSelector.removeClass("text-ss-grey");
    } else {
      brandSelector.addClass("text-ss-grey");
    }
    populateModel(brandSelector, modelSelector);
  });
  modelSelector.on("change", function () {
    if (modelSelector.children(":selected").val()) {
      modelSelector.removeClass("text-ss-grey");
    } else {
      modelSelector.addClass("text-ss-grey");
    }
  });


  $("#modelSelectorForm").on("submit", function (e) {
    e.preventDefault();
    const brand = brandSelector.val() as string;
    const model = modelSelector.val();
    if (brand && model) {
      const modelInfo = getModelInfo(brand, model as string);
      window.location.href = `/radio-models/${modelInfo?.slug}`;
    } else {
      $("#selectBoth").css("display", "block");
    }
  });

  populateBrands(brandSelector);
  if (brandSelector.children(":selected")?.val()) {
    populateModel(brandSelector, modelSelector);
  }
});
